<script lang="ts" setup>
	defineProps<{
		label?: string
	}>()
</script>
<template>
	<button type="button" class="back-btn group gap-x-2 p-[10px_22px] sm:p-[12px_18px_12px_16px] justify-center">
		<tools-icon dir="arrows" icon="arrow-backward" />
		<span class="text-gray-700 font-medium capitalize opacity-0 absolute transition-opacity text">
			{{ label }}
		</span>
	</button>
</template>

<style scoped>
	.back-btn {
		transform-origin: left;
		transition: all 500ms cubic-bezier(0.42, 0, 0.02, 0.71);
		@apply cursor-pointer
		z-50
		rounded-full
		flex
		items-center
		justify-center;
	}
</style>
<!-- 
	hover:md:w-[120px]
	hover:md:px-5
	hover:justify-normal;


-->
